import dateDistanceLegacy from './dateDistance';
import digitLegacy from './digit';
import dowLegacy from './dow';
import emailAddressLegacy from './emailAddress';
import excludeLegacy from './exclude';
import greaterThanLegacy from './greaterThan';
import gtLegacy from './gt';
import inDaysLegacy from './inDays';
import lengthLegacy from './length';
import lowercaseLegacy from './lowercase';
import ltLegacy from './lt';
import matchLegacy from './match';
import notZeroLegacy from './notZero';
import phoneNumberLegacy from './phoneNumber';
import regexpLegacy from './regexp';
import requiredLegacy from './required';
import specialLegacy from './special';
import uniqueLegacy from './unique';
import uppercaseLegacy from './uppercase';
import validateLegacy from './validate';

export function converToGlueValidation(fn) {
  return (props = {}) =>
    (k, param, values) => {
      const response = fn(values[k], { ...param, ...props, values });
      return props.msg && response ? props.msg : response;
    };
}

export const dateDistance = converToGlueValidation(dateDistanceLegacy);
export const digit = converToGlueValidation(digitLegacy);
export const dow = converToGlueValidation(dowLegacy);
export const emailAddress = converToGlueValidation(emailAddressLegacy);
export const exclude = converToGlueValidation(excludeLegacy);
export const greaterThan = converToGlueValidation(greaterThanLegacy);
export const gt = converToGlueValidation(gtLegacy);
export const inDays = converToGlueValidation(inDaysLegacy);
export const length = converToGlueValidation(lengthLegacy);
export const lowercase = converToGlueValidation(lowercaseLegacy);
export const lt = converToGlueValidation(ltLegacy());
export const match = converToGlueValidation(matchLegacy);
export const notZero = converToGlueValidation(notZeroLegacy);
export const phoneNumber = converToGlueValidation(phoneNumberLegacy);
export const regexp = converToGlueValidation(regexpLegacy);
export const required = converToGlueValidation(requiredLegacy);
export const special = converToGlueValidation(specialLegacy);
export const unique = converToGlueValidation(uniqueLegacy);
export const uppercase = converToGlueValidation(uppercaseLegacy);
export const validate = converToGlueValidation(validateLegacy);
